export const shouldWrapText = (text) => {
    // if (text.startsWith('"')) {
    //   return true
    // }
    // try {
    //   JSON.stringify(JSON.parse(text), null, 4);
    //   return false
    // } catch (err) {
    //   return true;
    // }
    return true;
};

export const getPrettyJson = (jsonData) => {
    try {
        return JSON.stringify(JSON.parse(jsonData), null, 4);
    } catch (err) {
        return jsonData;
    }
}